import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LogoutButton.scss';
import PrimaryButton from '../../common/components/Buttons/PrimaryButton';

/** Logout Button component */
function LogoutButton() {
  // const dispatch = useDispatch();
  // const { logout } = useAuth0WithRedux();
  const navigate = useNavigate();

  const onLogoutClicked = () => {
    navigate('/logout', { replace: true });
    // dispatch(resetApplicationStore());
    // logout();
  };

  return (
    <PrimaryButton onClick={onLogoutClicked} data-testid="btn-logout">
      Logout
    </PrimaryButton>
  );
}

export default LogoutButton;
